var map = {
	"./template.betprofessor": 1616,
	"./template.betprofessor.tsx": 1616,
	"./template.betroyale": 1617,
	"./template.betroyale.tsx": 1617,
	"./template.default": 669,
	"./template.default.tsx": 669,
	"./template.juicybet": 1618,
	"./template.juicybet.tsx": 1618,
	"./template.puntcity": 1619,
	"./template.puntcity.tsx": 1619,
	"./template.questbet": 1620,
	"./template.questbet.tsx": 1620,
	"./template.ts": 497,
	"./template.vikingbet": 1621,
	"./template.vikingbet.tsx": 1621,
	"./template.wellbet": 1622,
	"./template.wellbet.tsx": 1622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2458;